'use client'

import React, { useEffect, useState } from 'react'
import { useAddToCart } from './AddCart'
import Link from 'next/link'
import { getLocalStorage } from '@/lib/localStorage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

const PreorderCard = ({ campaign, onClick }) => {
    if (!campaign) return null
    const { addToCart, contextHolder } = useAddToCart()

    // กรองและนับจำนวนเล่มที่ปล่อยแล้ว
    const totalVolumes = campaign.total_volumes ?? 0
    const releasedVolumes = campaign.volumes?.filter(v => v.status === 'released').length ?? 0

    const firstVolume = campaign.volumes?.[0]
    const bookSeriesId = firstVolume?.prebookseries?.id
    const bookImage = firstVolume?.prebookseries?.book_image || "https://eve-image.eveebook.com/image.eveebook/web_image/tag/no_image.png"
    const partnerId = campaign.partner?.id || firstVolume?.prebookseries?.partner_id
    const partnerName = campaign.partner?.name || firstVolume?.prebookseries?.partner?.name
    const [getpre, setGetpre] = useState([])

    useEffect(() => {
        const stored = getLocalStorage('Preorder')
        if (stored) {
            try {
                const parsed = typeof stored === 'string' ? JSON.parse(stored) : stored
                setGetpre(Array.isArray(parsed) ? parsed : [])
            } catch (e) {
                console.error('Error parsing Preorder from localStorage:', e)
            }
        }
    }, [])

    const cartData = {
        // book_series_id: bookSeriesId,
        name: campaign.title,
        series_number: firstVolume?.volume_number || 0,
        partner_id: partnerId,
        partner_name: partnerName,
        coin_price: Number(campaign.preorder_price),
        book_image: bookImage,
        author: firstVolume?.prebookseries?.author?.name || '',
        preorder_id: campaign.id,
        type: 'preorder_campaign'
    }


    return (
        <div
            onClick={onClick}
            className="card p-3 my-2 rounded-xl  transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_20px_rgba(0,0,0,0.08)] group h-full select-none text-primary"
        >
            {contextHolder}
            {/* Cover Wrapper (กล่องใส่รูป) */}
            <div
                onClick={() => window.open(`/preorder/${campaign.id}`, "_blank")}
                className="relative cursor-pointer overflow-hidden rounded-lg border border-secondary bg-secondary flex items-center justify-center py-8"
            >

                {/* Desktop Hover Overlay */}
                {!getpre.includes(cartData.partner_id) &&
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-30 hidden md:flex">
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                addToCart(cartData);
                            }}
                            className="bg-[#FF347F] cursor-pointer hover:bg-[#EC008C] text-white text-xs font-bold py-2 px-3 rounded-lg shadow-lg transform translate-y-2 group-hover:translate-y-0 transition-all duration-300"
                        >
                            เพิ่มเข้าตะกร้า
                        </button>
                    </div>
                }


                {/* ป้าย Pre-order สไตล์พรีเมียม */}
                <div className="absolute top-0 right-0 bg-gradient-to-br from-gray-900 to-gray-700 text-[#d4af37] px-3 py-1 text-[0.7rem] font-bold rounded-bl-xl shadow-md z-20 tracking-wider">
                    PRE-ORDER
                </div>

                {/* Stacked Books (ปรับขนาดให้เข้ากับกรอบ) */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {campaign.volumes && campaign.volumes.length > 0 ? (
                        campaign.volumes.slice(0, 3).map((data, index) => (
                            <div
                                key={data.id || index}
                                style={{
                                    marginLeft: index === 0 ? '0' : '-35px',
                                    zIndex: 10 - index,
                                    position: 'relative',
                                    transition: 'transform 0.3s ease',
                                    transform: index % 2 === 0 ? 'rotate(-4deg)' : 'rotate(4deg)',
                                }}
                                className="group-hover:scale-105"
                            >
                                <img
                                    src={data.prebookseries?.book_image || "https://eve-image.eveebook.com/image.eveebook/web_image/tag/no_image.png"}
                                    alt={data.volume_title || `volume ${index + 1}`}
                                    style={{
                                        width: '90px',
                                        height: '130px',
                                        objectFit: 'cover',
                                        borderRadius: '4px',
                                        border: '2px solid white',
                                        boxShadow: '2px 4px 10px rgba(0,0,0,0.2)',
                                    }}
                                />
                            </div>
                        ))
                    ) : (
                        <div className="w-[90px] h-[130px] bg-gray-300 rounded border-2 border-white shadow-md flex items-center justify-center text-gray-400 text-3xl">
                            📚
                        </div>
                    )}
                </div>
            </div>
            {/* ข้อมูลเนื้อหา */}
            <div className="pt-4 flex flex-col justify-between h-[180px] sm:h-[150px]">
                <Link target="_blank" href={`/preorder/${campaign.id}`}>
                    <div className="text-md cursor-pointer font-bold text-primary  line-clamp-2 leading-snug transition-colors duration-300">
                        {campaign.title}
                    </div>
                    <div className="text-sm text-secondary mt-1.5 flex flex-col sm:flex-row sm:justify-between ">
                        <span className='text-sm'>ทั้งหมด {totalVolumes} เล่ม</span>
                        <span className='text-xs'>วางขายแล้ว {releasedVolumes} เล่ม</span>
                    </div>
                    <div className="text-sm text-secondary mt-1">
                        {campaign.partner?.name || ''}
                    </div>
                </Link>
                {getpre.includes(cartData.partner_id) ? (
                    <div className='  items-center mt-3 pt-3 border-t border-[#858d9738] text-success flex gap-2 items'><FontAwesomeIcon icon={faCheckCircle} /> มีแล้ว</div>
                ) : (
                    <div className="flex justify-between items-center mt-3 pt-3 border-t border-[#858d9738]">
                        <div className="flex flex-col sm:flex-row sm:justify-between w-full ">
                            <span> {campaign.normal_price && (
                                <span className=' line-through decoration-2  text-xs'>฿{campaign.normal_price}</span>)}
                            </span>
                            <span className="text-special font-bold ">฿{campaign.preorder_price}</span>
                        </div>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                addToCart(cartData);
                            }}
                            className="cursor-pointer p-2 lg:hidden text-white rounded-md flex items-center justify-center shadow"
                        >
                            <img className="h-[20px] w-[20px]" src="https://eve-image.eveebook.com/image.eveebook/mascot/basket1.png" alt="add_basket" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PreorderCard
